/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Uploading_To_ConnectInputs */

const en_ateliere_connect_status_uploading_to_connect = /** @type {(inputs: Ateliere_Connect_Status_Uploading_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading to Connect...`)
};

const fr_ateliere_connect_status_uploading_to_connect = /** @type {(inputs: Ateliere_Connect_Status_Uploading_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléversement vers Connect...`)
};

const de_ateliere_connect_status_uploading_to_connect = /** @type {(inputs: Ateliere_Connect_Status_Uploading_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird hochgeladen...`)
};

const it_ateliere_connect_status_uploading_to_connect = /** @type {(inputs: Ateliere_Connect_Status_Uploading_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento su Connect...`)
};

const ru_ateliere_connect_status_uploading_to_connect = /** @type {(inputs: Ateliere_Connect_Status_Uploading_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка в Connect...`)
};

const es_ateliere_connect_status_uploading_to_connect = /** @type {(inputs: Ateliere_Connect_Status_Uploading_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subiendo a Connect...`)
};

const zh_cn2_ateliere_connect_status_uploading_to_connect = /** @type {(inputs: Ateliere_Connect_Status_Uploading_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在上传到 Connect...`)
};

const ja_ateliere_connect_status_uploading_to_connect = /** @type {(inputs: Ateliere_Connect_Status_Uploading_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect にアップロードしています...`)
};

const hi_ateliere_connect_status_uploading_to_connect = /** @type {(inputs: Ateliere_Connect_Status_Uploading_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कनेक्ट पर अपलोड हो रहा है...`)
};

const pt_pt2_ateliere_connect_status_uploading_to_connect = /** @type {(inputs: Ateliere_Connect_Status_Uploading_To_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando...`)
};

/**
* | output |
* | --- |
* | "Uploading to Connect..." |
*
* @param {Ateliere_Connect_Status_Uploading_To_ConnectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_uploading_to_connect = /** @type {((inputs?: Ateliere_Connect_Status_Uploading_To_ConnectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Uploading_To_ConnectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_uploading_to_connect(inputs)
	if (locale === "de") return de_ateliere_connect_status_uploading_to_connect(inputs)
	if (locale === "it") return it_ateliere_connect_status_uploading_to_connect(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_uploading_to_connect(inputs)
	if (locale === "es") return es_ateliere_connect_status_uploading_to_connect(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_uploading_to_connect(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_uploading_to_connect(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_uploading_to_connect(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_uploading_to_connect(inputs)
	return en_ateliere_connect_status_uploading_to_connect(inputs)
});